import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { Preferences } from "@capacitor/preferences";

import Login from "./pages/Login";
import Home from "./pages/Home";
import Members from "./pages/Members";
import Events from "./pages/Events";
import Conversations from "./pages/ConversationsList";
import Chat from "./pages/Chat";
import Register from "./pages/Register";
import NewConversation from "./pages/NewConversation";
import Profile from "./pages/Profile";

import Planches from "./pages/Planches";
import Music from "./pages/Music";
import Lodges from "./pages/Lodges";
import Call from "./pages/Call";
import PdfViewer from "./pages/PdfViewer";

import usePush from "./hooks/usePush";
import Layout from "./components/Layout";
import API from "./api";
import ResetPasswordScreen from "./pages/ResetPasswordScreen";
import { App as CapApp } from "@capacitor/app";

const socket = io("https://api.joss-serveur.duckdns.org");

function App() {
  usePush();

  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [notifications, setNotifications] = useState({});

  const clearSession = async () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");

    await Preferences.remove({ key: "token" });
    await Preferences.remove({ key: "refreshToken" });
  };

  const checkAuth = async () => {
    try {
      const { value: token } = await Preferences.get({ key: "token" });

      if (!token) {
        await clearSession();
        setIsAuthenticated(false);
        setAuthChecked(true);
        return;
      }

      API.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      await API.get("/me");

      setIsAuthenticated(true);
    } catch (err) {
      console.log("Auth invalide:", err);
      await clearSession();
      setIsAuthenticated(false);
    } finally {
      setAuthChecked(true);
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await API.get("/conversations");

      const notif = {};
      res.data.forEach((c) => {
        notif[c.id] = c.unread_count;
      });

      setNotifications(notif);
    } catch (err) {
      console.log("Erreur notifications:", err);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    fetchNotifications();

    socket.on("notification", () => {
      fetchNotifications();
    });

    return () => {
      socket.off("notification");
    };
  }, [isAuthenticated]);

  useEffect(() => {
  CapApp.addListener("appUrlOpen", (event) => {
    console.log("Deep link reçu :", event.url);

    const slug = event.url.replace(
      "libertesolidaire://reset-password/open",
      "/reset-password"
    );

    if (slug) {
      window.location.replace(slug);
    }
  });
}, []);

  if (!authChecked) {
    return null;
  }

  return (
    <Router>

      <Routes>

        <Route
              path="/reset-password"
              element={<ResetPasswordScreen />}
            /> 
            
        {!isAuthenticated && (
          <>
            <Route path="/login" element={<Login />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        )}

        {isAuthenticated && (
          <>
            <Route path="/" element={<Navigate to="/home" replace />} />

            <Route
              path="/home"
              element={
                <Layout notifications={notifications}>
                  <Home />
                </Layout>
              }
            />

            <Route
              path="/members"
              element={
                <Layout notifications={notifications}>
                  <Members />
                </Layout>
              }
            />

            <Route
              path="/events"
              element={
                <Layout notifications={notifications}>
                  <Events />
                </Layout>
              }
            />

            <Route
              path="/messages"
              element={
                <Layout notifications={notifications}>
                  <Conversations />
                </Layout>
              }
            />

            <Route path="/pdf-viewer" element={<PdfViewer />} />


            <Route
              path="/new-chat"
              element={
                <Layout notifications={notifications}>
                  <NewConversation />
                </Layout>
              }
            />

            <Route
              path="/new-conversation"
              element={
                <Layout notifications={notifications}>
                  <NewConversation />
                </Layout>
              }
            />

            <Route
              path="/chat/:conversationId"
              element={
                <Layout notifications={notifications}>
                  <Chat />
                </Layout>
              }
            />

            <Route
              path="/register"
              element={
                <Layout notifications={notifications}>
                  <Register />
                </Layout>
              }
            />

            <Route
              path="/profile"
              element={
                <Layout notifications={notifications}>
                  <Profile />
                </Layout>
              }
            />

            <Route
              path="/planches"
              element={
                <Layout notifications={notifications}>
                  <Planches />
                </Layout>
              }
            />

            <Route
              path="/music"
              element={
                <Layout notifications={notifications}>
                  <Music />
                </Layout>
              }
            />

            <Route
              path="/lodges"
              element={
                <Layout notifications={notifications}>
                  <Lodges />
                </Layout>
              }
            />

            <Route path="/call/:userId" element={<Call />} />

            <Route path="*" element={<Navigate to="/home" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;